import { createSlice } from "../helper";

const leftNavSlice = createSlice({
    name: 'LeftNav',
    initialState: {
      sections: []
    },
    reducers:{
      updateExpandedTabId: (state, action) => {
        state.expandedTabId = action.payload.tabId
      },
      updateInitialData: (state,action) => {
        state.sections = action.payload.sections
      }
    }
})

export const leftNavActions =  leftNavSlice.actions;

export default leftNavSlice;

